//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { CommonHelper } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { IUserSession } from '../../../helpers/user-session'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { PopupType } from './../../../helpers/popup-manager'

import { Enums } from '../../../models/common/enums'
import { IOpObject, IReferenceType } from '../../../models/util/interfaces'
import { LoggerService } from '../../common/common.module'
import { OpLocation } from '../../../models/core/op-location'
import { OpLocationType } from '../../../models/core'
import { GroupingLocationHelper } from '../grouping-locations.helper'

interface GroupingLocationCreateEditScope extends CreateEditScope {}

export class GroupingLocationCreateEditController extends CreateEditController {

    // Members

    private referenceValue: OpLocation

    // Members End


    constructor(
        private $scope: GroupingLocationCreateEditScope,
        private $q: ng.IQService, 
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSession: IUserSession,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }


    // Events

    private onInit(args: any[]): void {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.referenceValue = createEditInitParams ? <OpLocation>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            
            if (this.referenceValue && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)

                if (createEditInitParams.customDataSources != null) {
                    const locTypes: IReferenceType[] = createEditInitParams.customDataSources.tryGetValue(Enums.ReferenceType.IdLocationType)

                    if (_.size(locTypes) === 1) {
                        if (createEditInitParams.customDataSourcesDefaultValues == null) {
                            createEditInitParams.customDataSourcesDefaultValues = {}
                        }

                        createEditInitParams.customDataSourcesDefaultValues[Enums.DataType.HELPER_ID_LOCATION_TYPE] = locTypes[0].getReferenceKey()
                    }
                }
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onInitBulk(args: any[]): void {
        if (args && args[0]) {
            const bulkEditInitParams: BulkEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)

            if (args && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }
            
            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        GroupingLocationHelper
            .saveGroupingLocation(this.userSession.getDataProvider(), OpLocation.fromIOpObject(objectToSave))
            .then((savedObject: OpLocation) => {
                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName))
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.groupingLocationSaved, true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                this.logger.log(error)

                CommonHelper.openInfoPopup(error, 'error', 5000)

                deferred.reject()
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        GroupingLocationHelper
            .saveGroupingLocation(this.userSession.getDataProvider(), OpLocation.fromIOpObject(objectToSave))
            .then((savedObject: OpLocation) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    // Events End


    // Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName), 
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName), 
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: '',
            type: null,
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
            onBulkSave: (objectToSave: IOpObject) => this.onBulkSave(objectToSave),
            onSubmit: null,
            onClose: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.groupingLocationSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
        }
    }

    // Setup End
}